export default __webpack_public_path__ + "static/logoBlack-13c963448c3dbabb1d6b22265e3e55e5.png";